import { startMouseMove } from "../../lib/utils/browser/mouseMove";
import { INJECT_UICORE_DESIGNER, INJECT_UICORE_BUS } from "../../lib/utils/consts";
import { injectFields, injectMethods } from "../../lib/utils/vue";
import { invoke, get } from "lodash-es";
import CompSkeleton from '../designer/CompSkeleton';
import TargetSlotSkeleton from '../designer/TargetSlotSkeleton';
import CRenderer from '../renderer/CRenderer';
import { calmComputed, walkLayout } from "../../lib/utils";
import { isArrayShallowEqual } from "../../lib/utils/array";
import DesignerKeyPressEventHandler from '../designer/utils/DesingerKeyPressEventHandler';
import { makeEffectStub } from '../utils';
const __script_base__ = {
  name: 'UcdEditZone',
  components: {
    CRenderer,
    // CSkeleton,
    CompSkeleton,
    TargetSlotSkeleton
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  data() {
    return {
      isPanning: false,
      // 按着空格，可以进入平移模式
      designerKeyPressEventHanlder: null,
      pageletsChangedTimes: 0,
      // 观察编辑区域尺寸
      setResizeObserver: makeEffectStub(el => {
        if (!el) return;
        const updateSize = () => {
          // eslint-disable-next-line max-len
          const height = el.offsetParent ? el.offsetParent.offsetHeight / this.designer.getZoomPercentage() : el.offsetHeight;
          const width = el.offsetWidth; // 直接 offsetHeight 可能会随内容膨胀，导致奇怪的问题，不要直接使用

          this.designer.pageWidthChange(width);
          this.designer.editSize.width = width;
          this.designer.editSize.height = height;
        };
        const resizeObserver = new ResizeObserver(updateSize);
        resizeObserver.observe(el);
        const stopWatchZoom = this.$watch(() => this.designer.zoom, updateSize);
        updateSize();
        return () => {
          resizeObserver.disconnect();
          stopWatchZoom();
        };
      }, (x, y) => x === y)
    };
  },
  computed: {
    ...injectFields('designer', ['rootRenderer', 'scope', 'pagelet', 'canvasRandom', 'isDragging', 'hoveringCompPath', 'compPath', 'activeComp', 'activeCompMeta']),
    state() {
      return this.designer.editZoneState;
    },
    componentsThatNeedsSpecialMarks: calmComputed(function () {
      var _this$designer$pagele;
      const ans = {};
      walkLayout((_this$designer$pagele = this.designer.pagelet) === null || _this$designer$pagele === void 0 ? void 0 : _this$designer$pagele.layout, ({
        layout,
        compPath
      }) => {
        if (layout.displayCondition || layout.renderCondition) {
          ans[compPath] = true;
        }
      });
      return Object.keys(ans);
    }, isArrayShallowEqual),
    filteredHighlightCompPaths() {
      const ans = {
        ...this.designer.highlightCompPaths
      };
      const {
        compPath,
        hoveringCompPath
      } = this.designer;
      const isInScopedSlot = this.designer.scopeStack.length;
      if (hoveringCompPath) ans[hoveringCompPath] = 'hovering';
      if (compPath || isInScopedSlot) ans[compPath] = 'selected';
      if (isInScopedSlot && !ans['']) ans[''] = '';

      // 如果报错太多会影响渲染性能
      if (!localStorage.getItem('uicore:ignoreErrorComp')) {
        var _this$designer$render, _this$designer$render2;
        const renderedCompInstances = ((_this$designer$render = this.designer.renderer) === null || _this$designer$render === void 0 ? void 0 : _this$designer$render.ucVNodeFactoryContext.componentInstances) || {};
        const errorCompPaths = Object.keys(((_this$designer$render2 = this.designer.renderer) === null || _this$designer$render2 === void 0 ? void 0 : _this$designer$render2.ucLayoutErrors) || {});
        let countLeft = 100; // 最多100个错误框，太多了会影响渲染性能
        errorCompPaths.some(compPath => {
          if (!renderedCompInstances[compPath]) return false; // 忽略未渲染的组件
          if (!ans[compPath]) ans[compPath] = '';
          countLeft -= 1;
          return !countLeft; // true 表示已经到达上限
        });
      }
      this.componentsThatNeedsSpecialMarks.forEach(compPath => {
        if (!ans[compPath]) ans[compPath] = '';
      });
      return ans;
    },
    currentDropHint() {
      return this.isDragging && this.state.currentDropHint || null;
    },
    dropHintRelatedCompPath() {
      var _this$currentDropHint;
      return ((_this$currentDropHint = this.currentDropHint) === null || _this$currentDropHint === void 0 ? void 0 : _this$currentDropHint.getRelatedCompPath()) || '';
    },
    editZoneCanvasStyle() {
      var _this$$refs$rendererC, _this$$refs$editZone, _this$$refs$rendererC2;
      // 尽量减少对100%缩放下的侵入
      // 页面贴靠左上角
      const style = this.designer.zoom === 100 ? {} : {
        transform: `scale(${this.designer.getZoomPercentage()})`,
        'transform-origin': '0 0'
      };
      if (this.designer.pageWidth === 'auto') {
        // auto状态下 按照缩放比例自动拓展页面宽度
        style['min-width'] = `${100 / this.designer.getZoomPercentage()}%`;
      } else {
        // 不为auto时直接锁定页面宽度
        const pageWidth = this.designer.pageWidth === 'mobile' ? 414 : this.designer.pageWidth;
        style['min-width'] = `${pageWidth}px`;
        style['max-width'] = `${pageWidth}px`;
      }

      // 添加依赖 在添加/删除组件时 刷新negativeMargin
      this.pageletsChangedTimes;
      // 底部固定留白
      const marginBottomStatic = this.designer.zoomFitState.editZoneBottomMargin ? 100 : 0;
      const canvasHeight = (_this$$refs$rendererC = this.$refs.rendererCanvas) === null || _this$$refs$rendererC === void 0 ? void 0 : _this$$refs$rendererC.offsetHeight;
      const editZoneHeight = (_this$$refs$editZone = this.$refs.editZone) === null || _this$$refs$editZone === void 0 ? void 0 : _this$$refs$editZone.offsetHeight;
      const oldMargin = get(invoke((_this$$refs$rendererC2 = this.$refs.rendererCanvas) === null || _this$$refs$rendererC2 === void 0 ? void 0 : _this$$refs$rendererC2.attributeStyleMap, 'get', 'margin-bottom'), 'value', 0);

      // 小于100%时将底部空白拉出滚动区域
      const zoom = this.designer.getZoomPercentage();
      // 缩放前CanvasHeight应该有的高度
      const origionCanvasHeight = canvasHeight + oldMargin;
      let negativeMargin = (-1 * origionCanvasHeight * (1 - zoom) + marginBottomStatic) / zoom;

      // 如果会把wrapper撑开 就是另一回事了 8 和 16 是editZone和wrapper的padding
      if (origionCanvasHeight > editZoneHeight - 8 - 16) {
        // 要继续撑开canvasWrapper 直到 canvasWrapper比canvas高100px
        negativeMargin = -1 * canvasHeight * (1 - zoom) + marginBottomStatic;
      }
      style['margin-bottom'] = `${negativeMargin}px`;
      return style;
    }
  },
  mounted() {
    this.syncRenderer();
    this.syncCompSkeletons();
    // 检测组件变动 拉起缩放style重新计算
    const refreshCanvasStyle = () => {
      this.pageletsChangedTimes += 1;
    };
    this.setResizeObserver(this.$refs.rendererCanvas);
    this.designer.uc.root.$on('update:pagelets', refreshCanvasStyle);
    refreshCanvasStyle();
  },
  beforeDestroy() {
    this.setResizeObserver(null);
  },
  updated() {
    this.syncRenderer();
    this.syncCompSkeletons();
    this.setResizeObserver(this.$refs.rendererCanvas);
  },
  methods: {
    ...injectMethods('designer', ['compFromPoint', 'modifyComp', 'modifyActiveComp', 'deleteActiveComp', 'pageWidthChange']),
    /**
     * 同步当前 designer.renderer 和 uc.renderer 为实际编辑的页面片的
     *
     * @private
     */
    syncRenderer() {
      this.rootRenderer = this.$refs.renderer;
      this.uc.renderer = this.rootRenderer;
      this.designerKeyPressEventHanlder = new DesignerKeyPressEventHandler(this.designer);
    },
    syncCompSkeletons() {
      const oldItems = this.state.compSkeletons;
      const selfRefs = this.$refs.compSkeletons || [];
      const hasChanges = selfRefs.length !== oldItems.size || selfRefs.some(x => !oldItems.has(x));
      if (hasChanges) {
        this.state.compSkeletons = new Set(selfRefs);
      }
    },
    focus() {
      this.$el.focus();
    },
    /** @param {MouseEvent} ev */
    handleEditZoneMouseDown(ev) {
      if (this.isPanning) {
        const editZone = this.$el;
        const oX = editZone.scrollLeft;
        const oY = editZone.scrollTop;
        const speed = 2;
        startMouseMove({
          initialEvent: ev,
          onMove: data => {
            editZone.scrollTo(oX - data.deltaX * speed, oY - data.deltaY * speed);
          }
        });
        ev.stopPropagation();
        ev.preventDefault();
      }
    },
    /** @param {KeyboardEvent} ev */
    handleEditZoneKeyDown(ev) {
      this.designerKeyPressEventHanlder.keyPressHandler(ev);
    },
    handleEditZoneKeyUp(ev) {
      const keyCode = ev.which || ev.keyCode;
      if (keyCode === 32 && this.isPanning) {
        this.isPanning = false;
        this.designer.currentOperation = '';
      }
    },
    handleCanvasMouseLeave() {
      this.designer.hoveringCompPath = '';
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.pagelet ? _c("div", {
    ref: "editZone",
    staticClass: "ucd-editZone",
    class: {
      isPanning: _vm.isPanning,
      isDragging: _vm.isDragging
    },
    attrs: {
      tabindex: "0"
    },
    on: {
      keydown: _vm.handleEditZoneKeyDown,
      keyup: _vm.handleEditZoneKeyUp,
      "!dragover": function ($event) {
        return _vm.state.handleEditZoneDragOverCapture.apply(null, arguments);
      },
      "!dragleave": function ($event) {
        return _vm.state.handleEditZoneDragLeaveCapture.apply(null, arguments);
      },
      "!drop": function ($event) {
        return _vm.state.handleEditZoneDropCapture.apply(null, arguments);
      },
      mousedown: _vm.handleEditZoneMouseDown,
      contextmenu: _vm.state.handleEditZoneContextMenu,
      mouseleave: function ($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.handleCanvasMouseLeave.apply(null, arguments);
      },
      wheel: _vm.state.handleEditZoneWheelZoom,
      scroll: _vm.state.handleScroll
    }
  }, [_c("div", {
    ref: "canvasWrapper",
    staticClass: "ucd-editZone-canvasWrapper",
    on: {
      click: function ($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.state.handleCanvasOutsideClick.apply(null, arguments);
      }
    }
  }, [_c("div", {
    key: "cCanvas::" + _vm.designer.pageletId + ":" + _vm.canvasRandom,
    ref: "rendererCanvas",
    staticClass: "ucd-editZone-canvas",
    style: _vm.editZoneCanvasStyle,
    attrs: {
      draggable: ""
    },
    on: {
      "!dragstart": function ($event) {
        return _vm.state.handleCanvasDragStartCapture.apply(null, arguments);
      },
      "!dragend": function ($event) {
        return _vm.state.handleCanvasDragEndCapture.apply(null, arguments);
      },
      "!mousemove": function ($event) {
        return _vm.state.handleCanvasMouseMoveCaptureStart.apply(null, arguments);
      },
      mousemove: _vm.state.handleCanvasMouseMoveCaptureEnd,
      "!mousedown": function ($event) {
        return _vm.state.handleComponentNativeMouseDownCapture.apply(null, arguments);
      },
      "!mouseup": function ($event) {
        return _vm.state.handleComponentNativeMouseUpCapture.apply(null, arguments);
      },
      "!click": function ($event) {
        return _vm.state.handleComponentNativeEventCapture.apply(null, arguments);
      },
      "!focus": function ($event) {
        return _vm.state.handleComponentNativeFocusCapture.apply(null, arguments);
      },
      "!selectstart": function ($event) {
        return _vm.state.handleComponentNativeEventCapture.apply(null, arguments);
      }
    }
  }, [_c("c-renderer", {
    ref: "renderer",
    staticClass: "ucd-editZone-renderer uc-component-wrapper",
    attrs: {
      uc: _vm.uc,
      "uc-initial-pagelet": _vm.designer.rootPagelet,
      "uc-data-sources-from-props": _vm.designer.rootDataSources,
      "uc-internal-is-root": true
    }
  })], 1)]), _vm._v(" "), _c("div", [_vm._l(_vm.filteredHighlightCompPaths, function (type, compPath) {
    return _c("comp-skeleton", {
      key: compPath,
      ref: "compSkeletons",
      refInFor: true,
      attrs: {
        "comp-path": compPath,
        "highlight-type": type
      }
    });
  }), _vm._v(" "), _vm.isDragging && _vm.state.isDraggingOver && _vm.state.targetSlotInfo ? _c("target-slot-skeleton", {
    attrs: {
      info: _vm.state.targetSlotInfo
    }
  }) : _vm._e(), _vm._v(" "), _vm.dropHintRelatedCompPath ? _c("comp-skeleton", {
    key: "dropHintRelated:" + _vm.dropHintRelatedCompPath,
    attrs: {
      "comp-path": _vm.dropHintRelatedCompPath,
      "highlight-type": "dropHintRelated"
    }
  }) : _vm._e()], 2)]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/EditZone.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);